import * as type from './types';
import axios from '../../../common/config/axios';

export const getMemberRegisterOrigin = (data) => dispatch => {
    axios.get('member/member_register_origin', {
        params: data
    }).then((response) => {
        dispatch({
            type: type.GET_MEMBER_REGISTER_ORIGIN,
            payload: response
        })
    }).catch(err => {
        console.warn(err);
    })
};

export const showMemberRegisterOriginDetails = (data) => dispatch => {
    axios.get('member/show_member_register_origin_details', {
        params: data
    }).then((response) => {
        dispatch({
            type: type.SHOW_MEMBER_REGISTER_ORIGIN_DETAILS,
            payload: response
        })
    }).catch(err => {
        console.warn(err);
    })
};